export const FormLabel = {
  baseStyle: {
    mb: '1',
    fontSize: 'sm',
    fontFamily: 'body !important',
    fontWeight: 'medium',
    color: 'font.ink',
  },
};
